import { UseQueryResult, useQuery } from "react-query";
import { gql } from "graphql-request";
//import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { IFilteredColumn } from "@funcional/react-table-ui";
import { CursorPaginated } from "@types";
import { IRefundProgram } from "../contracts";
import { GraphQLClient } from "graphql-request";
import { useAuth } from "react-oauth2-pkce";

let page = 1;
let refundType;
let refundTypeFilter = true;
let program;
let programFilter = true;
let headquarter;
let headquarterFilter = true;

enum RefundType {
  DIRETA = "direta",
  INDIRETA = "indireta",
}
export interface RefundProgramFilter {
  programName?: string;
  headquartersName?: string[];
  refundType?: RefundType;
  before?: string;
  after?: string;
  first?: number;
  last?: number;
  page?: number;
}
export interface UseRefundProgramOptions {
  gridFilters?: IFilteredColumn[];
  filter?: RefundProgramFilter;
}

//Retirar quando a query for plugada no core
export function usePbm2Url() {
  const { authService } = useAuth();
  const jwt = authService.getAuthTokens().access_token;
  const graphQLClient = new GraphQLClient(
    "https://pdr-refund-stg.funcionalcorp.net.br/graphql",
    {
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    }
  );

  return {
    graphQLClient,
    request: graphQLClient.request.bind(graphQLClient),
  };
}

export function useRefundPrograms(
  options: UseRefundProgramOptions | undefined = {}
): UseQueryResult<CursorPaginated<IRefundProgram>> {
  const { request } = usePbm2Url();

  if (options.gridFilters) {
    const filter: RefundProgramFilter = options.filter || {};
    options.gridFilters?.forEach((filteredColumn: any) => {
      if (filteredColumn.id === "program") {
        filter.programName = filteredColumn.value;
        if (programFilter) {
          program = filteredColumn.value;
          programFilter = false;
        }
        if (program !== filteredColumn.value) {
          page = 1;
          program = filteredColumn.value;
        }
      }
      if (filteredColumn.id === "headquarter") {
        filter.headquartersName = [filteredColumn.value];
        if (headquarterFilter) {
          headquarter = filteredColumn.value;
          headquarterFilter = false;
        }
        if (headquarter !== filteredColumn.value) {
          page = 1;
          headquarter = filter.headquartersName;
        }
      }
      if (filteredColumn.id === "refundType") {
        filter.refundType = filteredColumn.value;
        if (refundTypeFilter) {
          refundType = filter.refundType;
          refundTypeFilter = false;
        }
        if (refundType !== filter.refundType) {
          page = 1;
          refundType = filter.refundType;
        }
      }
      if (filteredColumn.id === "after") filter.after = filteredColumn.value;
      if (filteredColumn.id === "before") filter.before = filteredColumn.value;
      if (filteredColumn.id === "last") filter.last = filteredColumn.value;
    });

    options.filter = { ...filter, first: options.filter?.first || 10 };
  }

  return useQuery<CursorPaginated<IRefundProgram>, Error>(
    "refundPrograms" + JSON.stringify(options),
    async () => {
      if (options.filter?.after && page !== 0) page += 1;
      if (options.filter?.before && page > 1) page -= 1;

      const { searchAllHeadquarterPrograms } = await request(
        gql`
          query searchAllHeadquarterPrograms(
            $input: SearchAllHeadquarterProgramsInput!
          ) {
            searchAllHeadquarterPrograms(searchAllHeadquarterPrograms: $input) {
              pageInfo {
                pageCount
                totalCount
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
              }
              edges {
                node {
                  id
                  startDate
                  endDate
                  RefundType {
                    Id
                    Name
                  }
                  Headquarters {
                    IdHeadQuarter
                    NameHeadquarter
                  }
                  Programs {
                    IdProgram
                    NameProgram
                    Code
                  }
                }
              }
            }
          }
        `,
        {
          input: { ...options.filter, page },
        }
      );

      const nodes = searchAllHeadquarterPrograms?.edges.map((value) => {
        const node = value.node;
        return {
          node: {
            startDate: node.startDate,
            endDate: node.endDate,
            program: node.Programs.NameProgram,
            refundType: node.RefundType.Name,
            headquarter: node.Headquarters.NameHeadquarter,
          },
        };
      });

      const result = {
        pageInfo: {
          ...searchAllHeadquarterPrograms?.pageInfo,
          pageCount: searchAllHeadquarterPrograms?.edges.length,
        },
        edges: nodes,
      };
      return result as CursorPaginated<IRefundProgram>;
    }
  );
}
